import { ViewMode } from '../types'

interface FinderSkeletonProps {
    viewMode: ViewMode
}

export function FinderSkeleton({ viewMode }: FinderSkeletonProps) {
    if (viewMode === 'list') {
        return (
            <div className='bg-white rounded-2xl border border-gray-100 overflow-hidden shadow-sm'>
                <div className='p-4 space-y-3'>
                    {[1, 2, 3, 4, 5].map(i => (
                        <div key={i} className='flex items-center gap-4 animate-pulse'>
                            <div className='w-4 h-4 bg-gray-200 rounded' />
                            <div className='w-5 h-5 bg-gray-200 rounded' />
                            <div className='flex-1 h-4 bg-gray-200 rounded' />
                            <div className='w-16 h-4 bg-gray-100 rounded' />
                            <div className='w-20 h-4 bg-gray-100 rounded' />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div className='flex flex-wrap gap-3'>
            {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
                <div key={i} className='w-28 p-3 bg-white border border-gray-100 rounded-xl animate-pulse'>
                    <div className='w-12 h-12 mx-auto bg-gray-200 rounded-lg mb-2' />
                    <div className='w-full h-3 bg-gray-200 rounded mb-1' />
                    <div className='w-2/3 h-2 bg-gray-100 rounded mx-auto' />
                </div>
            ))}
        </div>
    )
}
